import React from "react";
export const SingleRowsSection = ({ rows, styleConfig }) => {
  if (!rows) return null;
  return rows.map((row) => <SingleRow key={row.id} row={row} styleConfig={styleConfig} />);
};

const SingleRow = ({ row, styleConfig }) => {
  let defaultStyleConfig = { rowClass: "s_row_c", rowLabelClass: "s_row_lc", rowValueClass: "s_row_vc" };
  if (styleConfig) defaultStyleConfig = { ...defaultStyleConfig, ...styleConfig };
  return (
    <div className={defaultStyleConfig.rowClass}>
      {row.label && <div className={defaultStyleConfig.rowLabelClass}>{row.label}</div>}
      <div className={defaultStyleConfig.rowValueClass}>{row.value}</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/CommonUI/Sections/SingleRowSection.js